// initial state
import axios from "axios";

const state = () => ({
    suppliers: [],
    currencies: [],
    invoices: [],
    supplier_invoices: [],
    expenses: []
})

// getters
const getters = {}

// actions
const actions = {
    async getData({commit}, params) {
        axios.get(route('frontend.fixture.get_supplier_invoices_config', params.fixture_id)).then(result => {
            commit('setSuppliers', result.data.suppliers)
            commit('setCurrencies', result.data.currencies)
            commit('setExpenses', result.data.expenses)
        });
    },
    async getLinkData({commit}, params) {
        axios.get(route('frontend.fixture.get_link_supplier_invoices_config', params.fixture_id)).then(result => {
            commit('setInvoices', result.data.invoices)
        });
    },
    async getLinkInvoiceData({commit}, params) {
        axios.get(route('frontend.fixture.get_link_invoices_config', params.fixture_id)).then(result => {
            commit('setSupplierInvoices', result.data)
        });
    }
}

// mutations
const mutations = {
    setSuppliers(state, suppliers) {
        state.suppliers = suppliers
    },
    setCurrencies(state, currencies) {
        state.currencies = currencies
    },
    setInvoices(state, invoices) {
        state.invoices = invoices
    },
    setSupplierInvoices(state, supplier_invoices) {
        state.supplier_invoices = supplier_invoices;
    },
    setExpenses(state, expenses) {
        state.expenses = expenses
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}